import { socket } from ".";


export const connectSocket = () => {
  if (!socket.connected) {
    socket.connect();
    console.log("Socket connecting...");
  }
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
    console.log("Socket disconnected");
  }
};